import React from 'react';

const base =
  'inline-flex items-center justify-center gap-2 rounded-lg font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-60 disabled:cursor-not-allowed';

const variants = {
  primary: 'bg-brand-blue text-white hover:bg-blue-600 focus:ring-brand-blue',
  secondary:
    'border border-[#D5D7DA] bg-white text-[#414651] hover:bg-slate-50 hover:border-slate-300 focus:ring-tertiary-700',
  tertiary:
    'border border-brand-orange text-brand-orange hover:border-brand-blue hover:text-brand-blue bg-white focus:ring-brand-blue',
};

const sizes = {
  small: 'px-3 py-2 text-sm',
  medium: 'px-4 py-2.5 text-base',
  large: 'px-5 py-3 text-lg',
};

const Button = ({
  children,
  variant = 'primary',
  size = 'medium',
  onClick,
  disabled = false,
  fullWidth = false,
  type = 'button',
  startIcon,
  endIcon,
  loading = false,
  className,
  ...props
}) => {
  const classes = [
    base,
    variants[variant] || variants.primary,
    sizes[size] || sizes.medium,
    fullWidth ? 'w-full' : '',
    className || '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={classes}
      {...props}
    >
      {startIcon && <span className="inline-flex items-center">{startIcon}</span>}
      <span>{loading ? 'Loading...' : children}</span>
      {endIcon && <span className="inline-flex items-center">{endIcon}</span>}
    </button>
  );
};

export default Button;

